<template>
    <div class="view view__auth_selfregistration">
        <auth-self-registration/>
    </div>
</template>

<script>

import AuthSelfRegistration from '@/components/auth/selfregistration/AuthSelfRegistration'
export default {
  name: 'view-auth-self-registration',
  components: { AuthSelfRegistration },
  computed: {
    routerRegisterKey () {
      return this.$route.params.key
    },
    registerKeyId () {
      return this.$store.getters.getLmsSuperadminWorkspaceRegisterKeyId
    }
  },
  beforeDestroy () {
    this.$store.dispatch('defaultWorkspaceClear')
    this.$store.dispatch('authUserClearSelfRegistration')
  },
  created () {
    if (!this.registerKeyId) {
      this.$router.push({ name: 'auth-validate-key', query: { registerKey: this.routerRegisterKey } })
    }
  }
}
</script>
